import { MENU_CODE_HEADER } from '@/utils/consts'

/** 여러 화면이 같이 부르는 API 의 요청 config — 부른 화면코드를 X-Menu-Code 로 실어 BE 감사 로그 MENU_CD 를 가른다(LOGISPRD-15645) */
export const menuCodeHeaders = (menuCode: string) => ({ headers: { [MENU_CODE_HEADER]: menuCode } })

/** 출고일정관리 gi27·gi28 이 같이 부르는 API(해외 우선순위·수용량)의 화면코드 */
export type ScheduleMenuCode = 'GI27' | 'GI28'
